/**
 * @Author: Caroline
 * @Desc: 修改vuex数据
 * @Date: 2021-3-17
 */

const mutations = {
  // 用工中心 - 任务列表
  setTaskList: function(state, val) {
    state.taskList = val;
  },

  //商户管理 -- 商户列表
  setCoopList: function(state, val) {
    state.coopList = val;
  },

  //数据中心管理 -- 自由职业者结算统计
  setProfessionalList: function(state, val) {
    state.professionalList = val;
  },

  //数据中心 -- 代理商交易统计
  setAgentList: function(state, val) {
    state.agentList = val;
  },

  //数据中心 -- 代理商交易历史统计
  setAgentHistoryList: function(state, val) {
    state.agentHistoryList = val;
  },

  //数据中心 -- 代理商交易统计详情
  setAgentDetailList: function(state, val) {
    state.agentDetailList = val;
  },

  //数据中心 -- 商户结算列表
  setMerchantSettleList: function(state, val) {
    state.merchantSettleList = val;
  },

  //数据中心 -- 批次交易明细
  setBatchTransDetailList: function(state, val) {
    state.batchTransDetailList = val;
  },

  // 财务中心 -- 余额管理 - 账单列表
  setBalanceAccList: function(state, val) {
    state.balanceAccList = val;
  },

  // 财务中心 -- 充值记录
  setRechargeRecordList: function(state, val) {
    state.rechargeRecordList = val;
  },

  // 用工中心 - 任务列表 - 报名详情
  setTaskWokersList: function(state, val) {
    state.taskWokersList = val;
  },

  // 用工中心 - 用工结算单
  setEmploymentStateList: function(state, val) {
    state.employmentStateList = val;
  },

  // 用工中心 - 用工结算单 - 提交结算单
  setEmploymentStateSubmitList: function(state, val) {
    state.employmentStateSubmitList = val;
  },

  // 用工中心 - 用工结算明细
  setEmploymentStateDescList: function(state, val) {
    state.employmentStateDescList = val;
  },

  // 历史用工结算明细
  setHistoryEmploymentInfoList: function(state, val) {
    state.historyEmploymentInfoList = val;
  },

  // 用工中心 - 自由职业者列表
  setProfessionList: function(state, val) {
    state.professionList = val;
  },

  // 用工中心 - 结算单风控列表
  setRiskControlList: function(state, val) {
    state.riskControlList = val;
  },

  // 用工中心 - 结算单风控列表
  setRiskControlList: function(state, val) {
    state.riskControlList = val;
  },

  // 资金下发管理 - 批次数据准备
  setSingleBatchDataList: function(state, val) {
    state.singleBatchDataList = val;
  },

  // 资金下发管理 - 批次数据准备  - 提交
  setSingleBatchDataSubmitList: function(state, val) {
    state.singleBatchDataSubmitList = val;
  },

  // 资金下发管理 - 多批次数据准备
  setMultiBatchDataList: function(state, val) {
    state.multiBatchDataList = val;
  },

  // 资金下发管理 - 多批次数据准备 - 提交
  setMultiBatchDataSubmitList: function(state, val) {
    state.multiBatchDataSubmitList = val;
  },

  // 资金下发管理 - 服务费明细列表
  setServiceChargeList: function(state, val) {
    state.serviceChargeList = val;
  },

  // 自由职业者管理 - 自由职业者信息管理
  setWorkersInfoList: function(state, val) {
    state.workersInfoList = val;
  },

  // 自由职业者管理 - 自由职业者签约状态
  setWorkersSignList: function(state, val) {
    state.workersSignList = val;
  },

  // 管理中心 - 账户管理
  setAccountChildList: function(state, val) {
    state.accountChildList = val;
  },

  // 财务中心 -- 电子回单
  setElectronicInfoList: function(state, val) {
    state.electronicInfoList = val;
  },

  //财务中心 -- 完税证明
  setTaxProveList: function(state, val) {
    state.taxProveList = val;
  },

  //财务中心 -- 完税证明详情
  setTaxProveDetailList: function(state, val) {
    state.taxProveDetailList = val;
  },

  //财务中心 -- 子账户余额
  setSubsidiaryBalanceList: function(state, val) {
    state.subsidiaryBalanceList = val;
  },

  //财务中心 -- 发票申请
  setInvoiceApplyList: function(state, val) {
    state.invoiceApplyList = val;
  },

  //任务中心 -- 任务中心列表
  setTaskCenList: function(state, val) {
    state.taskCenList = val;
  },

  // 任务中心 -- 任务中心列表 -- 任务中心详情
  setTaskCenDetailList: function(state, val) {
    state.taskCenDetailList = val;
  },

  // 自由职业者管理 -- 个体户信息管理
  setIndBusinessInfoManageList: function(state, val) {
    state.indBusinessInfoManageList = val;
  },

  // 用工中心 - 任务列表 - 任务详情 - 回收站
  setRecycleBinList: function(state, val) {
    state.recycleBinList = val;
  },

  // 自由职业者管理 -- 个体户订单管理
  setPerOrderList: function(state, val) {
    state.perOrderList = val;
  },

  // 合规中心 - 任务信息维护
  setComplianceCenter: function(state, val) {
    state.complianceCenter = val;
  },

  // 财务中心 - 开票记录
  setBillingRecordList: function(state, val) {
    state.billingRecordList = val;
  },

  // 财务中心 - 开票信息管理 - 开票类目列表
  setInvoiceCategoryList: function(state, val) {
    state.invoiceCategoryList = val;
  },

  // 数据中心 - 佣金结算订单
  setAgentBrokerageSettleRecord: function(state, val) {
    state.agentBrokerageSettleRecord = val;
  },

  // 用工中心 - 用工花名册
  setEmploymentRoster: function(state, val) {
    state.employmentRoster = val;
  },

  // 用工中心 - 测算工具分页
  setCalculationToolList: function(state, val) {
    state.calculationToolList = val;
  },

};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js